export default __webpack_public_path__ + "static/media/dispatch_flow.1c75280e.png";